/** The work this class has been given, and the scores that came back. */
import { useOutletContext } from 'react-router-dom';
import AssignmentsSection from '../AssignmentsSection';
import type { ClassDetailContext } from '../classDetailTypes';

function ClassAssignmentsPage() {
  const { offering, refetch } = useOutletContext<ClassDetailContext>();

  return (
    <AssignmentsSection
      classOfferingId={offering.id}
      gradebooks={offering.gradebooks ?? []}
      assignments={offering.assignments ?? []}
      onChanged={() => refetch()}
    />
  );
}

export default ClassAssignmentsPage;
